import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVirtualTrip } from "../../common/plannerTypes";
import { mergeLocalAndGlobalStates, updateLocalState } from "./plannerSliceHelper";
import { mapFromIScheduleToSingleVirtualTrip } from "../../components/Schedule/planner/virtualTripHelpers";
import _ from "lodash";

export interface ILocalChangesForTimelinePayload {
  tripPlannerId: string;
  updatedState: IVirtualTrip[];
}

export interface ILocalChangesForTimelineRemoveToRequestedPayload {
  tripPlannerId: string;
  virtualTripId: string;
  type:string;
}

export interface IPlannerState {
  localState: IVirtualTrip[];
  globalState: IVirtualTrip[];
  visualState: IVirtualTrip[];
  lastGlobalUpdateAt: string;
  lastLocalStateDiscardedAt: string;
  lastChangedNames: string;
}

const initialState: IPlannerState = {
  localState: [],
  globalState: [],
  visualState: [],
  lastGlobalUpdateAt: new Date().toISOString(),
  lastLocalStateDiscardedAt: new Date().toISOString(),
  lastChangedNames: "",
};

const plannerSlice = createSlice({
  name: "plannerStore",
  initialState,
  reducers: {
    resetLocalState(state: IPlannerState) {
      state.localState = [];
      state.visualState = mergeLocalAndGlobalStates(state.localState, state.globalState).filter(
        (q) => !q.deletedFromTimeLine && q.tripPlannerId !== null
      );
    },
    applyLocalChangesForTimeline(state: IPlannerState, action: PayloadAction<ILocalChangesForTimelinePayload>) {
      const otherPlannersLocalstateWithoutUpdatedTrips = state.localState.filter(
        (q) =>
          q.tripPlannerId !== action.payload.tripPlannerId &&
          !action.payload.updatedState.find((u: IVirtualTrip) => u.virtualTripId === q.virtualTripId)
      );
      state.localState = [...otherPlannersLocalstateWithoutUpdatedTrips, ...action.payload.updatedState];
      state.visualState = mergeLocalAndGlobalStates(state.localState, state.globalState).filter(
        (q) => !q.deletedFromTimeLine && q.tripPlannerId !== null
      );
    },
    applyLocalChangesForTimelineMoveToRequested(state: IPlannerState, action: PayloadAction<ILocalChangesForTimelineRemoveToRequestedPayload>) {
      const otherPlannersLocalstateWithoutUpdatedTrips = state.localState.filter((q) => q.virtualTripId !== action.payload.virtualTripId);
      const tripIndex = state.visualState.findIndex((q) => q.virtualTripId == action.payload.virtualTripId);
      const updatedTrips = _.cloneDeep(state.visualState[tripIndex]);

      if (action.payload.type == 'AD_HOC_REQUESTS') {
        if (updatedTrips && updatedTrips.transfers.length === 1) {
          updatedTrips.isTripMinOverrided = false;
          updatedTrips.overrideTripEstimateInMin = 0;
          updatedTrips.overridedendTrip = updatedTrips.endTrip;
          state.localState = [...otherPlannersLocalstateWithoutUpdatedTrips, updatedTrips];
        }
        else if (updatedTrips && updatedTrips.transfers.length > 1) {
          const updates: IVirtualTrip[] = []
          updatedTrips.transfers.forEach(tr => {
            const res = {
              ...mapFromIScheduleToSingleVirtualTrip(tr.scheduleObj),
              statusVT: 1,
              tripPlannerId: null,
              isMultiLoaded: false,
              isTripMinOverrided: false,
              overrideTripEstimateInMin: 0,
            }
            updates.push(res)
          });
          state.localState = [...otherPlannersLocalstateWithoutUpdatedTrips, ...updates];
        }
      }
      else {

        if (updatedTrips && updatedTrips.transfers.length === 1) {
          updatedTrips.statusVT = 1;
          updatedTrips.tripPlannerId = null;
          updatedTrips.isMultiLoaded = false;
          updatedTrips.isTripMinOverrided = false;
          updatedTrips.overrideTripEstimateInMin = 0;
          updatedTrips.overridedendTrip = updatedTrips.endTrip;
          state.localState = [...otherPlannersLocalstateWithoutUpdatedTrips, updatedTrips];
        } else if (updatedTrips && updatedTrips.transfers.length > 1) {
          const updates: IVirtualTrip[] = []
          updatedTrips.transfers.forEach(tr => {
            const res = {
              ...mapFromIScheduleToSingleVirtualTrip(tr.scheduleObj),
              statusVT: 1,
              tripPlannerId: null,
              isMultiLoaded: false,
              isTripMinOverrided: false,
              overrideTripEstimateInMin: 0,
            }
            updates.push(res)
          });
          state.localState = [...otherPlannersLocalstateWithoutUpdatedTrips, ...updates];
        }

      }

      state.visualState = mergeLocalAndGlobalStates(state.localState, state.globalState).filter(
        (q) => !q.deletedFromTimeLine && q.tripPlannerId !== null
      );
    },
    applyGlobalChanges(state: IPlannerState, action: PayloadAction<IVirtualTrip[]>) {
      const localStateUpdateResult = updateLocalState(state.localState, state.globalState, action.payload);
      const updatedAt = new Date().toISOString();
      if (localStateUpdateResult.isLocalStateChanged) {
        state.lastLocalStateDiscardedAt = updatedAt;
        state.lastChangedNames = localStateUpdateResult.changedNames;
      }
      state.lastGlobalUpdateAt = updatedAt;
      state.localState = localStateUpdateResult.updatedState;
      state.globalState = action.payload;
      state.visualState = mergeLocalAndGlobalStates(state.localState, state.globalState).filter(
        (q) => !q.deletedFromTimeLine && q.tripPlannerId !== null
      );
    },
  },
});

export const { applyLocalChangesForTimeline, applyLocalChangesForTimelineMoveToRequested, applyGlobalChanges, resetLocalState } =
  plannerSlice.actions;

export default plannerSlice.reducer;
